import React, { useEffect, useState } from 'react'
import icon from '../../../assets/shareholdersIcon.png'
import moment from 'moment';
import { numberWithCommas } from '../../../utils/formatNumber';
interface  RefundDetailsProps{
    refund:any
}
const RefundDetails = ({refund}:RefundDetailsProps) => {
    const [refundDetails, setRefundDetails] = useState<any[]>([]);
    useEffect(() => {
        const initialDetails = [
            { label: 'Transaction ID', value: refund.id },
            { label: 'Payment Type', value: refund.paymentType },
            { label: 'Order Reference', value: refund.orderReference },
            { label: 'Refund Reference', value: refund.refundReference },
            { label: 'Currency', value: refund.currency },
            { label: 'Refund Amount', value: numberWithCommas(refund.refundAmount) },
            { label: 'Total Amount', value: numberWithCommas(refund.amount) },
            { label: 'Fee', value: numberWithCommas(refund.fee) },
            { label: 'Customer Name', value: refund.customerName },
            { label: 'Customer Email', value: refund.customerEmail ?? 'Not Available' },
            { label: 'Status', value: refund.refundStatus },
            { label: 'Provider Response Message', value: refund.providerResponseMessage },
            { label: 'Provider Response Code', value: refund.providerResponseCode },
            { label: 'Provider Receipt', value: refund.providerReceipt },
            { label: 'Processor Provider Bank', value: refund.processorProviderBank },
            { label: 'Processor Provider UserName', value: refund.processorProviderUserName },
            { label: 'Date Created', value: moment(refund.dateCreated).format('DD-MMM-YYYY hh:mm:ss a') },
            { label: 'Original Transaction Date', value: moment(refund.orderDateCreated).format('DD-MMM-YYYY hh:mm:ss a') },

        ];

        setRefundDetails(initialDetails);
    }, [refund]);
    return (
        <div>
            <div>
                <img src={icon} className="my-3" alt="icon" />
                <div className="my-3">
                    <p className="text-xl font-bold">Refund Details</p>
                    <p className="text-sm">Kindly find your the details of your refund below</p>
                </div>
            </div>
            <div>
                {refundDetails.map((refund:any, index:any) => (
                    <div key={index}>
                        <div className="flex my-4 items-center text-xs">
                            <p>{refund.label}</p>
                            <p className="font-semibold ml-auto text-right">{refund.value}</p>
                        </div>
                        <hr />
                    </div>
                ))}
            </div>
        </div>
    )
}

export default RefundDetails
